import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewEncapsulation, EventEmitter, Output, OnChanges } from '@angular/core';
import { DtmService } from 'src/app/services/dtm.service';

// Services
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { pix2ndCopyErrors } from '../../constants/errors';
import { BankBilletData } from '../../model/bank-billet-data';
import { Contract } from '../../model/contract';
import { CreditCardData } from '../../model/credit-card-data';
import { CustomerAccount } from "../../model/customer-account";
import { PixData } from "../../model/pix-data";
import { SelfAttendanceService } from "../../services/self-attendance.service";
import { Dtm, getDtm, Mapping } from "../../enum/dtm";

import { CreditCard } from "../../model/credit-card";
import { environment } from "src/environments/environment";
import { ECommerceService } from "src/app/services/e-commerce.service";
import { SessionStorageService } from "../../services/session-storage.service";

import moment from 'moment';
import { Invoice } from '../../model/invoice';

@Component({
    // tslint:disable-next-line: component-selector
    selector: "pme-invoice",
    templateUrl: "./invoice.component.html",
    styleUrls: ["./invoice.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InvoiceComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @Input() creditCardData: CreditCardData;
  @Input() bankBilletData: BankBilletData;
  @Input() contract: Contract;
  @Input() hideBankBilletMessage: boolean;
  @Input() account: CustomerAccount;
  @Input() modalParams: any;
  @Input() newPayment: boolean;
  @Input() pixData: PixData;
  @Input() isInvestigate: boolean;
  @Input() isUpgrade: boolean = false;


  @Input() finalBalanceTrust: number;
  @Input() totalDebitTrust: number;
  @Input() invoice: Invoice;
  paidValueMessage: string = "Valor pago";
  trialData: boolean = false;
  creditCard: CreditCard;

  paymentMethod: string;
  expirationTime: number;
  totalValue: number;
  timeExpired: boolean = false;
  heroData: any = {};
  showPlan = false;
  showProduct = false;

  // Cupons
  extraBalanceCoupon: any;
  extraBalanceSum: number = 0;
  appliedCoupons: any = [];
  submitting: boolean;
  showHero: boolean = false;
  interval: NodeJS.Timeout;
  isPixPaid: boolean = false;
  classificationIdentifier: string;

  statusItp: string;
  codeErrorIpt: string;
  detailErrorIpt: string;
  messageErrorItp: string;

  showItp = false;

  @Output() onSuccessButtonClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private snackBarService: SnackBarService,
    private selfAttendanceService: SelfAttendanceService,
    public dtmService: DtmService,
    private eCommerceService: ECommerceService,
    private sessionStorageService: SessionStorageService
  ) { }

  ngOnChanges(): void {
    this.expirationTime = this.expirationTime && this.expirationTime > 0 ? this.expirationTime : (new Date(this.pixData?.pixExpiryTime).getTime() - new Date().getTime()) / 1000;
  }
  stringify(data: any): string {
    return JSON.stringify(data, null, 2);
  }

  invoiceSubtotal: number = 0;
  invoiceDiscount: number = 0;

  ngOnInit() {
    this.classificationIdentifier = sessionStorage.getItem(
      "classificationIdentifier"
    );
    if (!this.modalParams) {
      this.modalParams = {};
    }

    if (this.contract && this.contract.paymentMethod && this.contract.paymentMethod.identifier) this.paymentMethod = this.contract.paymentMethod.identifier;

    if (this.paymentMethod === 'BANK_BILLET') {
      this.totalValue = this.bankBilletData?.totalValue;
    } else if (this.paymentMethod === 'CREDIT_CARD') {
      this.totalValue = this?.creditCardData?.totalValue;
    } else if (this.paymentMethod === 'PIX') {
      this.totalValue = this.pixData?.totalValue;
      this.expirationTime =
        this.expirationTime && this.expirationTime > 0
          ? this.expirationTime
          : (new Date(this.pixData?.pixExpiryTime).getTime() -
            new Date().getTime()) /
          1000;
      if (this.pixData && !this.pixData.chargedUser) {
        this.clearDtm();
        this.dtmService.pageLoaded(
          Dtm.Processando,
          true,
          getDtm(Dtm.Processando, this.classificationIdentifier)
        );
        this.dtmService.productsLoaded([
          {
            classificationName:
              Mapping[this.classificationIdentifier] ||
              this.classificationIdentifier,
            identifier: this.contract.product.identifier,
          },
        ]);
        this.dtmService.sendPageLoadEvent();
      }
    }

    if (
      this.contract &&
      this.contract.product &&
      this.contract.product.classificationIdentifier
    ) {
      let plans = [
        "saude-do-seu-negocio",
        "monitore-clientes",
        "plano-mensal, descomplica",
      ];
      let products = [
        "consulta-e-recuperacao-de-dividas",
        "lista-online",
        "plano-mensal-recarga-pontual",
      ];
      if (plans.includes(this.contract.product.classificationIdentifier)) {
        this.showPlan = true;
      } else if (
        products.includes(this.contract.product.classificationIdentifier)
      ) {
        this.showProduct = true;
      }
    }

    if (this.pixData || this.bankBilletData || this.contract.status.includes("INVESTIGATE")) {
      this.paidValueMessage = "Valor a pagar";
    }

    if (this.contract.trialData) {
      let days = moment(this.contract.trialData.trialEndDate, "DD/MM/YYYY").diff(moment(this.contract.saleDate, "DD/MM/YYYY"), 'days');

      this.paidValueMessage = days + " dias de teste";
      this.creditCard = new CreditCard(this.contract.paymentMethod.creditCard);
    }

    if (this.invoice && this.invoice.invoiceItem) {
      this.invoiceSubtotal = this.invoice.invoiceItem[0].value;

      if (this.invoice.invoiceItem.length > 1) {
        this.invoiceDiscount = this.invoice.invoiceItem[1].value;
      }
    }
  }


  formatErrorMessage(errorStatus: string): void {
    switch (errorStatus) {
      case "PAYMENT_REJECTED":
        let businessId = this.contract.provisioningParameters.businessId;
        let userId = this.contract.provisioningParameters.userId;
        let url = environment.ecommerce_base_url + `/auto-atendimento/` + this.classificationIdentifier + `/alteracao-de-pagamento?businessId=` + businessId + `&userId=` + userId
        this.messageErrorItp = 'Desculpe, não foi possível concluir o pagamento via PIX devido à saldo suficiente na conta.<br><br>Você pode continuar a compra <b><a href="' + url + '">clicando aqui e selecionando uma outra forma de pagamento.</a></b>';

        this.dtmService.customErrorLoaded(["error"], {
          errorMessage: this.messageErrorItp,
        });
        break;
      case 'CONSENT_REJECTED':
        this.messageErrorItp = 'Desculpe, o pagamento não pode ser concluído porque você não aceitou o termo de consentimento na etapa de pagamento do banco.';

        this.dtmService.customErrorLoaded(["error"], {
          errorMessage: this.messageErrorItp,
        });
        break;
      default:
        this.messageErrorItp =
          "Lamentamos, <b>ocorreu um problema no processamento do seu pagamento Pix.</b>";
        this.dtmService.customErrorLoaded(["error"], {
          errorMessage: this.messageErrorItp
        });
    }
  }

  formatDecimalValue(value: number) {
    return Number.isInteger(value) ? value : value.toFixed(2).replace(".", ",");
  }

  automaticRechargeValueFormat() {
    let automaticRechargeValue = this.contract.product.automaticRecharge;
    return Number.isInteger(automaticRechargeValue) ? automaticRechargeValue : automaticRechargeValue.toFixed(2).replace('.', ',');
  }

  calculateFinalValue() {
    let finalValue = this.contract.product.value;

    if (this.creditCardData && this.creditCardData.appliedCoupons) {
      this.creditCardData.appliedCoupons.forEach((discount) => {
        if (discount.type === "EXTRA_BALANCE") {
          finalValue += discount.extraBalance;
        }
      });
    }

    if (this.pixData && this.pixData.appliedCoupons) {
      this.pixData.appliedCoupons.forEach((discount) => {
        if (discount.type === "EXTRA_BALANCE") {
          finalValue += discount.extraBalance;
        }
      });
    }

    return finalValue;
  }

  changePage() {
    this.timeExpired = !this.timeExpired;
    if (this.timeExpired) {
      clearInterval(this.interval);
      this.clearDtm();
      this.dtmService.pageLoaded(Dtm.CodigoPagamentoExpirouAutoAtendimento, true, getDtm(Dtm.CodigoPagamentoExpirouAutoAtendimento, this.classificationIdentifier));

      this.dtmService.sendPageLoadEvent();
    }
  }

  clearDtm() {
    this.dtmService.customLoaded([]);
    this.dtmService.productsLoaded([
      {
        classificationName: this.classificationIdentifier,
        identifier: this.contract.product.identifier,
      },
    ]);
  }

  getPix2ndCopy() {
    this.dtmService.pageLoaded(
      Dtm.NovoCodigoPixAutoAtendimento,
      true,
      getDtm(Dtm.NovoCodigoPixAutoAtendimento, this.classificationIdentifier)
    );
    this.dtmService.customClickEvent("Gerar novo código");
    this.submitting = true;
    this.selfAttendanceService
      .getPix2ndCopy(
        this.contract.provisioningParameters.businessId,
        this.contract.provisioningParameters.userId,
        this.contract.product.classificationIdentifier
      )
      .subscribe(
        (selfAttendanceData) => {
          if (selfAttendanceData?.pixData) {
            selfAttendanceData.businessId = this.contract.provisioningParameters.businessId;
            selfAttendanceData.userId = this.contract.provisioningParameters.userId;

            this.pixData = selfAttendanceData.pixData;

            this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
            this.expirationTime = (new Date(selfAttendanceData.pixData?.pixExpiryTime).getTime() - new Date().getTime()) / 1000;
            this.submitting = false;
            this.changePage();
          }
        },
        (error) => {
          this.showCustomError('pix2ndCopyError', error);
        }
      )
  }
  ngDoCheck() {
    if (this.isPixPaid === false) {
      this.isPixPaid = this.sessionStorageService.getPixPaid();
    }
  }
  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;
    switch (customErrorKey) {
      case "pix2ndCopyError":
        integrationErrorMessage = this.showCustomHeroError(
          integrationError,
          "pix2ndCopyError"
        );

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });

      default:
        break;
    }
  }

  showCustomHeroError(error, type) {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint
          }:${JSON.stringify(resultError.errors)}:${JSON.stringify(
            resultError.warnings
          )}`;

        resultError.userMessage = error.error._messages[0].text;
        resultError.code = error.error._messages[0].code;

        switch (type) {
          case "pix2ndCopyError":
            if (pix2ndCopyErrors[resultError.code]) {
              this.heroData.type = "warn";
              this.heroData.title = pix2ndCopyErrors[resultError.code].title;
              this.heroData.contents =
                pix2ndCopyErrors[resultError.code].contents;
            } else {
              this.heroData.type = "warn";
              this.heroData.title = "Serviço indisponível!";
              this.heroData.contents = [
                "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
              ];
            }
            break;
          default:
            this.heroData.type = "warn";
            this.heroData.title = "Serviço indisponível!";
            this.heroData.contents = [
              "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
            ];
            break;
        }
      }
    } catch (e) {
      console.error(e);
      resultError.errorString = JSON.stringify(error);
      this.heroData.type = "warn";
      this.heroData.title = "Serviço indisponível!";
      this.heroData.contents = [
        "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
      ];
    }

    this.heroData.showButton = true;
    this.heroData.buttonName = "Voltar";
    this.heroData.redirectURL = this.selfAttendanceService.redirectURL;
    //this.params.redirectUrl;

    this.showHero = true;
    return resultError;
  }

  ngAfterViewInit(): void {
    let additionalInfo = document.getElementById("additional-info");
    if (
      additionalInfo &&
      this.contract &&
      this.contract.provisioningParameters
    ) {
      additionalInfo.innerHTML = this.contract.provisioningParameters.additionalInfo;
    }

    // Confere cupons
    this.checkForExtraBalanceCoupon();

  }

  copied(event) {
    this.snackBarService.openSnackBar("Código copiado");
  }

  openBankBilletOnNewTab(url) {
    window.open(url, "_blank");
  }

  ngOnDestroy(): void { }

  calculateInstallments() {
    let paymentConditionIdentifier = this.contract.paymentMethod
      .paymentConditionIdentifier;
    let numberInstallments = paymentConditionIdentifier.match(/\d/g).join("");
    return parseInt(numberInstallments);
  }

  valueOfInstallments() {
    return this.totalValue ? this.totalValue / this.calculateInstallments() : this.contract.product.value / this.calculateInstallments();
  }

  getLastCreditCardNumbers(): string {
    if (this.creditCardData && this.creditCardData.number) {
      // Se o numero do cartao veio sem espaços
      if (this.creditCardData.number.indexOf(" ") < 0) {
        return `${this.creditCardData.number.slice(-4)}`;
      } else {
        const splittedNumber = this.creditCardData.number.split(' ');
        return `${splittedNumber[splittedNumber.length - 1]}`;
      }
    } else {
      if (this.creditCard) {
        return `${this.creditCard.number.slice(-4)}`
      }
    }
  }

  getPlanType() {
    let planType = this.contract.product.name.split("- ").pop();
    return planType;
  }

  checkForExtraBalanceCoupon() {
    this.appliedCoupons = [];
    this.extraBalanceCoupon = [];
    this.extraBalanceSum = 0;

    // Cartão de crédito
    if (this.creditCardData && this.creditCardData.appliedCoupons) {
      this.creditCardData.appliedCoupons.forEach((discount) => {
        if (discount.type === "EXTRA_BALANCE") {
          this.extraBalanceCoupon.push(discount);
        } else {
          this.appliedCoupons.push(discount);
        }
      });
    }

    // Boleto bancário
    if (this.bankBilletData && this.bankBilletData.appliedCoupons) {
      this.bankBilletData.appliedCoupons.forEach((discount) => {
        if (discount.type === "EXTRA_BALANCE") {
          this.extraBalanceCoupon.push(discount);
        } else {
          this.appliedCoupons.push(discount);
        }
      });
    }

    // PIX
    if (this.pixData && this.pixData.appliedCoupons) {
      this.pixData.appliedCoupons.forEach((discount) => {
        if (discount.type === "EXTRA_BALANCE") {
          this.extraBalanceCoupon.push(discount);
        } else {
          this.appliedCoupons.push(discount);
        }
      });
    }

    if (this.extraBalanceCoupon.length > 0) {
      this.extraBalanceSum = this.extraBalanceCoupon.reduce((accumulator, discount) => {
        return accumulator + discount.extraBalance;
      }, 0);
    }
  }


  pixPaid() {
    if (!this.newPayment) {
      this.interval = setInterval(() => this.consultRemittanceStatus(), this.pixData?.remittanceConsultsInterval);
    }
  }

  consultRemittanceStatus(): void {
    this.selfAttendanceService.getRemittanceStatus(this.pixData?.txid).subscribe(
      (result) => {

        if (result.remittance?.status) {
          this.isPixPaid = true;
          clearInterval(this.interval);
          // this.clearDtm();
          this.dtmService.pageLoaded(Dtm.PagamentoReconhecido, true, getDtm(Dtm.PagamentoReconhecido, this.classificationIdentifier));
          this.dtmService.sendPageLoadEvent();
        }
      }
    );
  }

}
